module.exports = __webpack_public_path__ + "img/logo.1549dc35.png";